export const convertClassNames = (stylesConvert: any = {}, classnames?: string) => {
    if (typeof classnames === 'string' && stylesConvert) {
        return classnames
            .split(' ')
            .map((item) => stylesConvert[item])
            .join(' ');
    }
    return classnames;
};
